import React, { useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { MyNewsListItem, MyNewsLoadingComponent } from "my-news/components";
import { useMyNewsList } from "my-news/hooks";
import { OcIconForState } from "oc/components";

interface MyNewsListProps {
  archived: boolean;
  isMobile: boolean;
}

export const MyNewsList: React.FC<MyNewsListProps> = ({
  archived,
  isMobile,
}) => {
  const theme = useTheme();
  const [pageSize, setPageSize] = useState(4);

  const { data, error, loading, handleFetchMore, setMyNewsItemRead } =
    useMyNewsList({
      archived,
    });

  const list = data?.rows || [];
  const loadMoreData = () => {
    setPageSize(pageSize + 4);
    handleFetchMore(pageSize);
  };

  return (
    <Box display="flex" flexDirection="column">
      <InfiniteScroll
        dataLength={pageSize}
        next={loadMoreData}
        hasMore={data?.total > list?.length}
        scrollThreshold={0.9}
        loader={null}
      >
        <MyNewsLoadingComponent
          isMobile={isMobile}
          loading={loading && !error && list?.length === 0}
        />
        <OcIconForState
          data={list}
          loading={loading}
          isMobile={isMobile}
          error={!!error}
          module="MyNews"
        />
        {list?.map((item: (typeof list)[number], index: number) => (
          <Box key={item._id}>
            <MyNewsListItem
              item={item}
              isAdminList={false}
              setMyNewsItemRead={setMyNewsItemRead}
            />
            <Box height="16px" />
            {item?.priority === "high" &&
              !item.read &&
              list[index + 1]?.priority === "normal" && (
                <Box
                  style={{
                    borderBottom: `1px solid ${theme.palette.gray40.main}`,
                    marginBottom: "16px",
                  }}
                />
              )}
          </Box>
        ))}
      </InfiniteScroll>
    </Box>
  );
};

export default MyNewsList;
